<template>
    <div>
        <div class="form-group first">
            <label for="state_id">* Estado</label>
            <select name="state_id"
                    id="state_id"
                    class="form-control"
                    @change="onChange"
                    v-model="selectedState"
            >
                <option :value="null">Selecione</option>
                <option v-for="state in states" :key="state.id" :value="state">
                    {{ state.name }}
                </option>
            </select>
        </div>
        <div class="form-group">
            <label for="location_id">* Cidade</label>
            <select name="location_id"
                    id="location_id"
                    class="form-control"
                    v-model="selectedCity"
                    :disabled="!selectedState"
                    @change="onSelectCity"
                    required
            >
                <option :value="null">Selecione</option>
                <option v-for="city in cities" :key="city.id" :value="city.id">
                    {{ city.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value'],
        data() {
            return {
                states: [],
                cities: [],
                selectedState: null,
                selectedCity: null,
            };
        },

        methods: {
            onChange() {
                this.cities = [];
                this.selectedCity = null;

                if (!this.selectedState) {
                    return;
                }

                axios.get(`/states/${this.selectedState.id}/cities_0`)
                    .then(({data}) => {
                        this.cities = data.data;
                    });
            },
            onSelectCity() {
                this.$emit('input', this.selectedCity);
            },
        },

        mounted() {
            axios.get('/states')
                .then(({data}) => {
                    this.states = data;
                });
        }
    }
</script>
